import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-documents-disclaimer',
  templateUrl: './documents-disclaimer.component.html',
  styleUrls: ['./documents-disclaimer.component.css'],
})
export class DocumentsDisclaimerComponent {}
